"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalFilesLauncher = void 0;
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const cancellable = __importStar(require("../model/cancellable"));
const loading_modal_1 = require("./loading-modal");
/** Prompts the user to choose a local file, uploads it to the designated temp folder and
*   passes the location of the uploaded file back to the calling code.
*/
class LocalFilesLauncher extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadingFile: null
        };
    }
    render() {
        var _a;
        const uploadFileToTemp = (file) => __awaiter(this, void 0, void 0, function* () {
            try {
                const uploadResult = yield this.props.FileService.uploadResource(this.props.TempFolder, file).Complete;
                if (uploadResult.Outcome !== "Succeeded") {
                    return uploadResult;
                }
                const resource = yield this.props.FileService.getResource(this.props.TempFolder.Concat(file.name));
                return cancellable.Succeeded(resource);
            }
            catch (error) {
                return cancellable.Failed(`${error}`);
            }
        });
        const onFileChange = (e) => __awaiter(this, void 0, void 0, function* () {
            const files = e.target.files ? [...e.target.files] : [];
            if (files.length > 0) {
                e.target.value = "";
                const targetPath = this.props.TempFolder.Concat(files[0].name);
                this.setState({
                    uploadingFile: targetPath
                });
                const result = yield uploadFileToTemp(files[0]);
                if (result.Outcome === "Succeeded") {
                    yield this.props.OnSubmit(result.Value);
                }
                else if (result.Outcome === "Failed") {
                    this.props.RaiseAlert(result.Error);
                }
                this.setState({
                    uploadingFile: null
                });
            }
        });
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("label", { style: { cursor: "pointer" }, htmlFor: "local-file-upload" },
                react_1.default.createElement("table", { className: "place-selector" },
                    react_1.default.createElement("tr", { style: { cursor: "pointer" }, onClick: () => { }, key: "Local Files" },
                        react_1.default.createElement("td", null,
                            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faDesktop, fixedWidth: true })),
                        react_1.default.createElement("td", null, "My Computer")))),
            react_1.default.createElement("input", { id: "local-file-upload", style: { display: "none" }, type: "file", onChange: onFileChange }),
            react_1.default.createElement(loading_modal_1.LoadingModal, { Show: !!this.state.uploadingFile, Message: `Uploading ${(_a = this.state.uploadingFile) === null || _a === void 0 ? void 0 : _a.Name}...` })));
    }
}
exports.LocalFilesLauncher = LocalFilesLauncher;
//# sourceMappingURL=local-files-launcher.js.map